var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile ? 'isMobile' : '',attrs:{"id":"app"}},[_c('keep-alive',{key:_vm.token},[_c('router-view')],1),(_vm.showUpdate)?_c('div',{staticClass:"update-toast"},[_c('span',[_vm._v("发现探数蚁新版本，是否立即更新？")]),_c('button',{on:{"click":_vm.reloadPage}},[_vm._v("立即更新")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }